var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-card vertical-card"},[_c('div',{staticClass:"img-container s-ratio-16-9 pointer"},[_c('img',{staticClass:"img-course-card s-transition",attrs:{"src":require("@/assets/default-course.png")},on:{"click":_vm.onClick}})]),_vm._v(" "),_c('div',{staticClass:"p-col-12 p-px-4 p-pt-3 vertical-card-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4108b920","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/VerticalCard.vue
// module id = +kH/
// module chunks = 38